import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transferwallet',
  templateUrl: './transferwallet.component.html',
  styleUrls: ['./transferwallet.component.scss']
})
export class TransferwalletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
